import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function debounce(func, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
    };
}

export function capitalizeWords(str = '') {
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

export function getAddressByType(addresses = [], type = 'HEADQUARTER') {
    return addresses.find(addr => addr.type === type) || {};
}

export function getValueByDataKey(data = [], key) {
    return data.find(item => item.key === key)?.value ?? null;
}
export function formatDate(isoString) {
    if (!isoString) return '-';
    const date = new Date(isoString);

    const day = date?.getDate();
    const month = date?.toLocaleString('en-US', { month: 'short' });
    const year = date?.getFullYear();

    return `${day} ${month} ${year}`;
}
